import { render, staticRenderFns } from "./HeaderLogout.vue?vue&type=template&id=6128e14e&"
import script from "./HeaderLogout.vue?vue&type=script&lang=ts&"
export * from "./HeaderLogout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports